import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  sidebarShow: true, // default state or load from localStorage or other source
  menuLinks: [],
  meneLoading: false,
}
export const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    setSidebarShow: (state, action) => {
      state.sidebarShow = action.payload
    },
    setMenuLinks: (state, action) => {
      state.menuLinks = action.payload
    },
    setMenuLinkLoading: (state, action) => {
      state.meneLoading = action.payload
    },
  },
})

export const { setSidebarShow, setMenuLinks, setMenuLinkLoading } = sidebarSlice.actions

export default sidebarSlice.reducer
